<template>
  <v-dialog
    v-model="open"
    max-width="700px"
    persistent
    :attach="true"
    eager
    content-class="release-notes-dialog"
  >
    <v-card>
      <v-toolbar dark color="primary px-2">
        <v-toolbar-title>Software Updates</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-4">
        <div style="display: flex;gap: 0.5em;"><h3 class="mb-2">Release Date:</h3> <b>{{ notes.release_date }}</b></div>
        <h3 class="mb-2">{{ notes.title }}</h3>
        <div class="caption" v-if="notes.date">Released: {{ notes.date }}</div>

        <template v-if="notes.features && notes.features.length">
        <div v-html="notes.features" @click="handleLinkClick"> </div>

        <div class="image-modal-container" v-if="notes.release_img">
          <img :src="notes.release_img" alt="Update Image">
        </div>

        </template>
        <v-alert v-else type="info" outlined>
          No release notes available
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-space-between pa-4">
          <v-checkbox
          v-model="dontShowAgain"
          label="Don't show again for this version"
          hide-details
        />
        <!-- Got it = persist only if checkbox is ticked -->
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn color="primary" v-else @click="gotIt">Got it</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import userAPI from '@/api/user.js';

export default {
  name: 'ReleaseNotesDialog',
  data: () => ({
    open: false,
    dontShowAgain: false,
    devHintVisible: false,
    currentVersion: process.env.VUE_APP_VERSION,
    notes: {},
    loading: false
  }),

  mounted() {
    this.open = this.$store.getters.releaseDialog;
    this.notes = this.$store.getters.releaseUpdate;
  },

  methods: {
    // Close: do NOT persist => will show again next load
    close() {
      this.open = false
      this.$store.commit('setReleaseDialog', false);
    },

    // Got it: persist only if checkbox is ticked
    gotIt() {
      if (this.dontShowAgain) {
        this.loading = true;
        userAPI.releaseSeen(this.notes.id).then(() => {
          this.loading = false;
          this.$store.commit('setReleaseDialog', false);
          this.open = false
        });        
      }else{
        this.open = false
        this.$store.commit('setReleaseDialog', false);
      }
    },
     handleLinkClick(event) {
      // Check if the clicked element is a link
      if (
        event.target.tagName === 'A' ||
        event.target.parentElement.tagName === 'A'
      ) {
        // Prevent the default action of the click event
        event.preventDefault();
        // Get the link URL
        const linkUrl =
          event.target.tagName === 'A'
            ? event.target.href
            : event.target.parentElement.href;
        // Open the link URL in a new tab
        window.open(linkUrl, '_blank');
      }
    },
  },
}
</script>

<style scoped>
/* Keep dialog above headers/backdrops/menus */
.release-notes-dialog {
  z-index: 3005 !important;
}

.image-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  background: white;
  border-radius: 8px;
}

.image-modal-container img {
  max-width: 100%;
  max-height: 30vh;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
</style>
